import { Modal } from '@/components/Modal'
import { Content } from './Content'
import { modalId } from '../hooks/useController'

export function Root() {
  return (
    <Modal modalId={modalId}>
      <Content />
    </Modal>
  )
}
